


















































































import { Vue, Component, Prop, Emit, Watch, PropSync } from "vue-property-decorator";
import { mapState } from "vuex";
import { ProductInfoState } from "@/store/ProductStore";
import { ProductInfoProperties } from "@/models/graphql-global-types";

@Component({
  computed: mapState("productStore", ["productInfo"])
})
export default class ProductProperties extends Vue {
  public productInfo!: ProductInfoState;
  @Prop() public product!: any;
  @Prop({ default: false }) public readonly isEditing!: boolean;

  public proposedCustomerProductDescription: string | null = null;
  public useProposedCustomerProductDescription: boolean = true;

  public shouldShowCustomerProductDescriptionHint(field: ProductInfoProperties) {
    return (
      field === ProductInfoProperties.CUSTOMER_PRODUCT_DESCRIPTION &&
      this.proposedCustomerProductDescription &&
      this.product.properties[ProductInfoProperties.CUSTOMER_PRODUCT_DESCRIPTION] !==
        this.proposedCustomerProductDescription
    );
  }

  public useProposedValue() {
    this.product.properties[
      ProductInfoProperties.CUSTOMER_PRODUCT_DESCRIPTION
    ] = this.proposedCustomerProductDescription;
    this.product.properties = Object.assign({}, this.product.properties);
    this.useProposedCustomerProductDescription = true;
  }

  public didFocusField(field: ProductInfoProperties) {
    if (field === ProductInfoProperties.CUSTOMER_PRODUCT_DESCRIPTION) {
      this.useProposedCustomerProductDescription = false;
    }
  }

  private generateProposedCustomerDescription() {
    const customer = this.product.properties[ProductInfoProperties.CUSTOMER];
    let screwType = this.product.properties[ProductInfoProperties.SCREW_TYPE]?.name;
    let head = this.product.properties[ProductInfoProperties.HEAD]?.name;
    let recessType = this.product.properties[ProductInfoProperties.RECESS_TYPE]?.name;
    let recessSize = this.product.properties[ProductInfoProperties.RECESS_SIZE]?.name;
    const diameter = this.product.properties[ProductInfoProperties.DIAMETER];
    const length = this.product.properties[ProductInfoProperties.LENGTH];
    let threadType =
      this.product.properties[ProductInfoProperties.THREAD_TYPE] &&
      this.product.properties[ProductInfoProperties.THREAD_TYPE][0]?.name;
    let surfaceColor = this.product.properties[ProductInfoProperties.SURFACE_COLOR]?.name;

    if (customer && screwType && head && recessType && recessSize && diameter && length && threadType && surfaceColor) {
      screwType = screwType.split("-")[0]?.trim();
      head = head.split("-")[0]?.trim();
      recessType = recessType.split("-")[0]?.trim();
      recessSize = recessSize.split("-")[0]?.trim();

      const recess = `${recessType}${recessSize}`.replace(/\s/g, "");

      threadType = threadType
        .split("-")[0]
        ?.replace("Thread", "")
        .trim();
      surfaceColor = surfaceColor.split("-")[0]?.trim();

      if (!threadType.toLowerCase().endsWith("thread")) {
        threadType = `${threadType}-Thread`;
      }

      const proposedProductDescription = `${customer} ${screwType} ${head} ${recess} ${diameter} x ${length} ${threadType} ${surfaceColor}`;
      this.proposedCustomerProductDescription = proposedProductDescription;
      if (this.useProposedCustomerProductDescription && !this.isEditing) {
        this.product.properties[ProductInfoProperties.CUSTOMER_PRODUCT_DESCRIPTION] = proposedProductDescription;
      }
    }
  }

  @Watch("product", { deep: true })
  public onProductChanged() {
    this.$validator.validateAll();
    this.product.isValid = this.$validator.errors.count() === 0;
    this.generateProposedCustomerDescription();
  }

  public mounted() {
    this.generateProposedCustomerDescription();
  }
}
